(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crm-order-tracking"] && !Shopify.designMode) return;
  try {
    
(function () {
  var FALLBACK_LABELS = {
    shipped: 'Order shipped',
    in_transit: 'In transit',
    arrived: 'Arrived at destination',
    out_for_delivery: 'Out for delivery',
    delivered: 'Delivered',
  };

  function getStepLabels(root) {
    return {
      shipped: root.getAttribute('data-label-step-shipped') || FALLBACK_LABELS.shipped,
      in_transit: root.getAttribute('data-label-step-in-transit') || FALLBACK_LABELS.in_transit,
      arrived: root.getAttribute('data-label-step-arrived') || FALLBACK_LABELS.arrived,
      out_for_delivery:
        root.getAttribute('data-label-step-out-for-delivery') || FALLBACK_LABELS.out_for_delivery,
      delivered: root.getAttribute('data-label-step-delivered') || FALLBACK_LABELS.delivered,
    };
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function renderItems(root, items, orderId) {
    var labels = getStepLabels(root);
    var awaitingLabel = root.getAttribute('data-label-awaiting') || '';

    return (items || [])
      .map(function (item) {
        var steps = item.steps || [];
        var anyReached = steps.some(function (step) {
          return step.reached;
        });
        var currentIndex = steps.findIndex(function (step) {
          return !step.reached;
        });

        var stepsHtml = steps
          .map(function (step, index, all) {
            var done = step.reached ? ' is-done' : '';
            var current = index === currentIndex ? ' is-current' : '';
            var lineClass =
              index < all.length - 1 && all[index + 1] && all[index + 1].reached ? ' is-done' : '';
            var line =
              index === all.length - 1
                ? ''
                : '<span class="c-track__line' + lineClass + '"></span>';
            var label = labels[step.key] || step.label;
            return (
              '<li class="c-track__step' +
              done +
              current +
              '"><span class="c-track__rail"><span class="c-track__dot"></span>' +
              line +
              '</span><span class="c-track__step-label">' +
              escapeHtml(label) +
              '</span></li>'
            );
          })
          .join('');

        var status =
          !anyReached && awaitingLabel
            ? '<p class="c-track__carrier">' + escapeHtml(awaitingLabel) + '</p>'
            : '';

        return (
          '<div class="c-track__item"><p class="c-track__item-name">' +
          escapeHtml(item.name || orderId) +
          '</p><ol class="c-track__steps">' +
          stepsHtml +
          '</ol>' +
          status +
          '</div>'
        );
      })
      .join('');
  }

  function initTracking(root) {
    if (!(root instanceof Element) || root.dataset.cTrackReady === 'true') return;
    var form = root.querySelector('[data-crm-track-form], form');
    var emailInput = root.querySelector('[data-crm-track-email]');
    var orderInput = root.querySelector('[data-crm-track-order]');
    var button = root.querySelector('[data-crm-track-submit]');
    var msg = root.querySelector('[data-crm-track-msg]');
    var result = root.querySelector('[data-crm-track-result]');
    if (!form || !emailInput || !orderInput || !button) return;

    root.dataset.cTrackReady = 'true';
    var endpoint = (root.getAttribute('data-endpoint') || '').trim();
    endpoint = endpoint.replace(/^(https?:)\/(?!\/)/i, '$1//');
    endpoint = endpoint.replace(/^(https:\/\/)https?:\/+/i, '$1');
    if (endpoint && endpoint.indexOf('://') === -1) {
      endpoint = 'https://' + endpoint.replace(/^\/+/, '');
    }
    var shop = root.getAttribute('data-shop') || '';
    var token = root.getAttribute('data-token') || '';

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (msg) {
        msg.hidden = true;
        msg.textContent = '';
      }
      if (result) result.innerHTML = '';
      button.disabled = true;

      try {
        var response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            shop: shop,
            token: token,
            email: emailInput.value,
            orderId: orderInput.value,
          }),
        });
        var body = await response.json();
        if (response.status === 403 || !response.ok) throw new Error('lookup failed');
        if (!body.found) {
          if (msg) {
            msg.textContent = root.getAttribute('data-label-not-found') || '';
            msg.hidden = false;
          }
          return;
        }
        if (result) result.innerHTML = renderItems(root, body.items, body.orderId);
      } catch (error) {
        if (msg) {
          msg.textContent = root.getAttribute('data-label-error') || '';
          msg.hidden = false;
        }
      } finally {
        button.disabled = false;
      }
    });
  }

  function initAll(scope) {
    var root = scope instanceof Element ? scope : document;
    root.querySelectorAll('[data-c-track]').forEach(initTracking);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
